<template>
  <div class="register">
    <v-topBar :yellowPageColumn='yellowPageColumn' :productAndSolutionColumn='productAndSolutionColumn'
              :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"></v-topBar>
    <v-registerTop :navTitle="navTitle" :webConfigInfo='webConfigInfo'></v-registerTop>
    <!-- <div class="setNavBg">
      <v-header :navigationColumnInfos='navigationColumnInfos' :webConfigInfo='webConfigInfo'  ></v-header>
    </div> -->
    <div class="registerCon">
      <p style="position:absolute;top:-48px;left:0px;">新一链网已经上线，如您要在新一链网参与项目，请点击此处注册新一链网：<a
        style="padding: 5px 10px;background: #3F88E0;color: #ffffff;text-decoration: none;"
        href="https://ebs.onelinkplus.com/web-user-center/index.html#/reg">注册新一链网</a></p>
      <h3>请选择您的身份，填写企业名称</h3>
      <p class="register-tips">如有疑问，您可在 <a id="zzfw_span" @click="goToHref('/helpCenter')">自助服务</a>，获得帮助
      </p>
      <div class="roleBtn">
        <div class="roleBtnLeft">
          <el-button @click="purchaserFn" class="purchaserBtn">我是采购商
            <span class="register-unchoose"></span>
          </el-button>
          <p>我要采购商品/服务</p>
        </div>
        <div class="roleBtnLeft">
          <el-button @click="supplierFn" class="supplierBtn">我是供应商
            <span class="register-unchoose"></span>
          </el-button>
          <p>我要提供商品/服务</p>
        </div>
      </div>
      <div class="roleCon">
        <el-form @submit.native.prevent :model="ruleForm" :rules="rules" ref="registerForm" label-width="195px"
                 class="demo-ruleForm">
          <el-form-item label="境内外供应商" prop="region" v-show="abroadShow">
            <el-radio-group v-model="ruleForm.regAddrType" @change="changeAddrType">
              <el-radio label="0">境内</el-radio>
              <el-radio label="1">境外及特殊企业</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="*" class="abroadTips" v-show="selectAddrType=='1'" style="margin-top: -22px;">
            <p>特殊企业特指社会组织、律师事务所、事业单位或其他不在工商部门注册的组织</p>
          </el-form-item>
          <el-form-item label="企业名称" prop="companyName" v-if="fileTypeFlag">
            <!--<el-select  v-model="ruleForm.companyName"  filterable placeholder="请输入企业名称后，点击'搜索'选择企业" remote reserve-keyword size=10  :remote-method="loadCompanys" @change="selectCompany" >-->
            <!--<el-option v-for="item in companyData"-->
            <!--:key="item.id+','+item.name"-->
            <!--:label="item.name"-->
            <!--:value="item.id+','+item.name">-->
            <!--</el-option>-->
            <!--</el-select>-->
            <!--<el-button @click="operateCompany()"  type="primary">搜索</el-button>-->

            <el-input maxlength=50 v-model="ruleForm.companyName" @keyup.enter.native="loadCompanys"
                      placeholder="请输入企业名称后，点击'搜索'选择企业"></el-input>
            <transition name="el-zoom-in-top">
              <div v-show="companyListShow" class="baseList">
                <el-radio-group v-model="selectCompanyName" @change="selectCompany">
                  <el-radio v-for="(item,index) in companyData" :key="index" :label="item.name">{{ item.name }}
                  </el-radio>
                </el-radio-group>
              </div>
            </transition>
            <el-button :disabled="searchDis" @click="loadCompanys">搜索</el-button>
          </el-form-item>
          <el-form-item label="注册证明" prop="licenceCode" v-if="!fileTypeFlag">
            <el-input v-model="ruleForm.licenceCode" placeholder="请填写商业登记注册证明/执业许可证号/统一社会信用代码"
                      style="width:380px"/>
          </el-form-item>
        </el-form>
        <p class="isAgree">
          <el-checkbox v-model="userChecked">我已阅读，并同意<a @click="userAgreementVisible=true"
                                                               href="#">一链网用户协议</a></el-checkbox>
        </p>
        <p class="isAgree">
          <el-checkbox v-model="privacyChecked">我已阅读，并同意<a @click="privacyPolicyVisible=true"
                                                                  href="#">一链网隐私策略</a></el-checkbox>
        </p>
        <el-button @click="submitForm('ruleForm')" class="register_next">继续</el-button>
        <p class="count-out" v-show="!abroadShow && ruleForm.orgIdentity != ''">点击【继续】代表您已阅读并同意《协议》和《隐私策略》<br>若您是海外用户，请联系客服:0516-87796393
        </p>
        <p class="count-out" v-if="!abroadShow && ruleForm.orgIdentity == ''">
          点击【继续】代表您已阅读并同意《协议》和《隐私策略》</p>
        <p class="count-out" v-if="abroadShow ">点击【继续】代表您已阅读并同意《协议》和《隐私策略》</p>
      </div>
    </div>
    <el-dialog title="一链网用户协议" :visible.sync="userAgreementVisible" custom-class="registerDialog">
      <div id="alert-box1" class="alert-box layui-layer-wrap" style="display: block;max-height: 440px">
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">
            本协议阐述之条款和条件(以下合称“条款”)适用于您使用一链网。一链网依据以下条款为您提供所享有的服务，请仔细阅读并遵守。
          </span>
        </p>
        <p
          style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0;text-align:left;line-height:30px;background:white;vertical-align: baseline">
          <strong>
            <span style="font-size:18px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266">
            一、条款的确认和接受
            </span>
          </strong>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">1</span>
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">
            、一链网平台（指onelinkplus.com及其移动客户端软件、应用程序，以下称“本网站”）各项电子服务的所有权和运作权归属于一链网所有，本网站提供的服务将完全按照其发布的服务条款和操作规则严格执行。您确认所有服务条款并完成注册程序时，本协议在您与本网站间成立并发生法律效力，同时您成为本网站正式用户。
          </span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">2</span><span
          style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">、根据国家法律法规变化及本网站运营需要，一链网有权对本协议条款及相关规则不时地进行修改，修改后的内容一旦以任何形式公布在本网站上即生效，并取代此前相关内容，您应不时关注本网站公告、提示信息及协议、规则等相关内容的变动。您知悉并确认，如您不同意更新后的内容，应立即停止使用本网站；如您继续使用本网站，即视为知悉变动内容并同意接受。</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">3</span><span
          style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">、您点击“同意”按钮即视为您完全接受本协议，在点击之前请您再次确认已知悉并完全理解本协议的全部内容。</span>
        </p>
        <p
          style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0;text-align:left;line-height:30px;background:white;vertical-align: baseline">
          <strong><span
            style="font-size:18px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266">二、条款的修改</span></strong>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">1</span><span
          style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">、一链网有权根据业务需要酌情修订条款，并以网站公告的形式在相关页 面进行更新，不再单独通知您。经修订的条款一经公布，即产生效力。如您不同意相关修订，请您立即主动停止使用服务；如您继续使用服务，则将视为您已接受条款的变动。</span>
        </p>
        <p
          style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0;text-align:left;line-height:30px;background:white;vertical-align: baseline">
          <strong><span
            style="font-size:18px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266">三、账号、密码</span></strong>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">1</span><span
          style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">、服务使用对象</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">您确认，在您完成注册程序或以其他一链网允许的方式实际使用服务时，您应当是具备完全民事权利能力和与所从事的民事行为相适应的行为能力的自然人、法人或其他组织。若您不具备前述主体资格，请勿使用服务，否则您及您的监护人应承担因此而导致的一切后果，且一链网有权注销（永久冻结）您的账户，并向您及您的监护人索偿。如您代表一家公司或其他法律主体在一链网登记，则您应向一链网提供该公司或其他法律主体所出具的授权委托书，委托书中应载明该公司或其他法律主体授权您对在一链网注册的账号进行管理，并且同意承担相关的法律后果。</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">2</span><span
          style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">、注册账户</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">账号、密码为您在一链网首页注册的账号、密码，应妥善保管。同时，在完成注册或认证流程时，您应当按照法律法规要求，按相应页面的提示准确提供并及时更新您的资料，以使之真实、及时，完整和准确。如有合理理由怀疑您提供的资料错误、不实、过时或不完整的，一链网有权向您发出询问或要求改正的通知，并有权直接做出删除相应资料的处理，直至终止对您提供部分或全部服务，一链网对此不承担任何责任，您将承担因此产生的任何直接或间接损失及不利后果。</span>
        </p>
        <p
          style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0;text-align:left;line-height:30px;background:white;vertical-align: baseline">
          <strong><span
            style="font-size:18px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266">四、账户安全</span></strong>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">您可自行决定更换密码，若您发现自己的账号被他人非法使用或存在安全漏洞的情况，应立即通知一链网。</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">在一链网内，同一企业可以注册多个账号，请使用属于自己的个人账号，并妥善保管好您的账号、密码。一链网不承担任何由于共用账号引起的信息泄漏和误操作风险。</span>
        </p>
        <p
          style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0;text-align:left;line-height:30px;background:white;vertical-align: baseline">
          <strong><span style="font-size:18px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266">五、服务风险制度</span></strong>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">使用一链网服务的用户自行承担全部风险，一链网不对提供的服务作任何明示或暗示的保证，同时亦不对商业性的隐含担保，特定目的和不违反规定的适当担保作限制。包括但不限于：一链网不担保服务一定能满足用户的要求，不担保服务不会中断，及对服务的及时性、安全性、出错或文件丢失的发生，不承担任何赔偿责任。</span>
        </p>
        <p
          style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0;text-align:left;line-height:30px;background:white;vertical-align: baseline">
          <strong><span
            style="font-size:18px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266">六、关于费用</span></strong>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">一链网保留收取服务费用的权利。另外，您因进行交易、向一链网获取有偿服务或接触一链网服务器而发生的所有应纳税赋，以及相关硬件、软件、通讯、网络服务及其他方面的费用均由您自行承担。一链网保留在无须发出书面通知，仅在网站公示的情况下，暂时或永久地更改或停止部分或全部服务的权利。</span>
        </p>
        <p
          style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0;text-align:left;line-height:30px;background:white;vertical-align: baseline">
          <strong><span
            style="font-size:18px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266">七、使用规则</span></strong>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">一链网不对任何有关信息内容的真实性、适用性、合法性承担责任。您对服务的使用是根据所有适用于服务的地方法律、国家法律和国际法律标准的。</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">您同意并承诺：</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">1</span><span
          style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">、在一链网上发布信息或者利用一链网的服务时必须符合中国有关法律、法规，不得在一链网上或者利用一链网的服务制作、复制、发布、传播以下信息：</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">a)</span><span
          style="font-size: 16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">反对宪法所确定的基本原则的；</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">b)</span><span
          style="font-size: 16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">c)</span><span
          style="font-size: 16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">损害国家荣誉和利益的；</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">d)</span><span
          style="font-size: 16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">煽动民族仇恨、民族歧视、破坏民族团结的；</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">e)</span><span
          style="font-size: 16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">破坏国家宗教政策，宣扬邪教和封建迷信的；</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">f)</span><span
          style="font-size: 16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">散布谣言，扰乱社会秩序，破坏社会稳定的；</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">g)</span><span
          style="font-size: 16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">h)</span><span
          style="font-size: 16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">侮辱或者诽谤他人，侵害他人合法权益的；</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">i)</span><span
          style="font-size: 16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">含有法律、行政法规禁止的其他内容的。</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">2</span><span
          style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">、在利用一链网服务时还必须符合其他有关国家和地区的法律规定以及国际法的有关规定。</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">3</span><span
          style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">、不利用一链网的服务从事以下活动：</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">a)</span>
          <span
            style="font-size: 16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">未经允许，进入计算机信息网络或者使用计算机信息网络资源的；</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">b)</span><span
          style="font-size: 16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">未经允许，对计算机信息网络功能进行删除、修改或者增加的；</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">c)</span><span
          style="font-size: 16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加的；</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">d)</span><span
          style="font-size: 16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">故意制作、传播计算机病毒等破坏性程序的；</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">e)</span><span
          style="font-size: 16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">其他危害计算机信息网络安全的行为。</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">4</span><span
          style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">、不以任何方式干扰一链网的服务。</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">5</span><span
          style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">、遵守一链网的所有其他规定和程序。</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">您需对自己在使用一链网服务过程中的行为承担法律责任。用户理解，如果一链网发现其消息内容明显属于上段第1条所列内容之一，依据中国法律，一链网有义务立即停止其服务，保存有关记录，向国家有关机关报告，并且删除含有该内容的消息。</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">6</span><span
          style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">、您使用一链网服务必须遵守国家有关法律和政策等，维护国家利益，保护国家安全，并遵守本协议，对于您违法或违反本协议的使用而引起的一切责任，由您负全部责任，一概与一链网无关，导致一链网损失的，一链网有权要求您赔偿，并有权立即停止提供服务，保留相关记录，保留配合司法机关追究法律责任的权利。</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">7</span><span
          style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">、用户之间通过一链网与其他用户交易，因受误导或欺骗而导致或可能导致的任何心理、生理上的伤害以及经济上的损失，由过错方依法承担所有责任，一概与一链网无关。</span>
        </p>
        <p
          style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0;text-align:left;line-height:30px;background:white;vertical-align: baseline">
          <strong><span
            style="font-size:18px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266">八、廉洁承诺</span></strong>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">供应商企业在一链网内，需在其参与的招标项目、询报价项目、采购合同获取和履约等过程中递交《廉洁自律承诺书》。经查实存在以下情形和行为的企业，将被列入一链网“黑名单供应商名册”，两年内（情节严重的五年及以上）禁止参与一链网的任何采购事项。同时一链网会将该等事项如实披露给使用一链网进行招标的采购方用户。</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">列入黑名单供应商名册的情形和行为包括但不限于：</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">1</span><span
          style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">、商业贿赂；</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">2</span><span
          style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">、资质材料弄虚作假；</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">3</span><span
          style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">、以不正当方式谋求入围投标；</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">4</span><span
          style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">、无正当理由拒不参加一链网邀请投标或中途退出投标的；</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">5</span><span
          style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">、在招标过程中有串标、围标行为；</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">6</span><span
          style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">、在招标过程中存在挂靠行为或关联方重复投标的；</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">7</span><span
          style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">、在招标过程中恶意诽谤、诬告和陷害其他竞争对手的；</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">8</span><span
          style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">、非法以他人名义投标和以其他方式弄虚作假骗取中标的；</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">9</span><span
          style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">、报价不实、低价位承诺未兑现；</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">10</span><span
          style="font-size: 16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">、出现严重违反投标承诺或合同约定，提高价格、降低质量、拖延工期或者供货时间等不诚信行为的；</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">11</span><span
          style="font-size: 16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">、出现所供物资以次充好、以假充真等商业欺诈行为的；</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">12</span><span
          style="font-size: 16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">、出现重大质量问题引发重大事故的；</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">13</span><span
          style="font-size: 16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">、内部管理混乱，多头授权，扰乱正常经营秩序的；</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">14</span><span
          style="font-size: 16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">、聚众闹事，严重影响一链网正常生产的；</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">15</span><span
          style="font-size: 16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">、具有虚假、恶意质疑与投诉，损害采购商（招标企业或其所属企业）形象、声誉等其他严重不良行为的；</span>
        </p>
        <p
          style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0;text-align:left;line-height:30px;background:white;vertical-align: baseline">
          <strong><span
            style="font-size:18px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266">九、通知</span></strong>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">您应当准确填写并及时更新您提供的电子邮件地址、联系电话、联系地址、邮政编码等联系方式，以便一链网或其他用户与您进行有效联系，因通过这些联系方式无法与您取得联系，导致您在使用一链网服务过程中产生任何损失或增加费用的，应由您完全独自承担。您了解并同意，您有义务保持你提供的联系方式的有效性，如有变更需要更新的，您应按一链网的要求进行操作。</span>
        </p>
        <p
          style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0;text-align:left;line-height:30px;background:white;vertical-align: baseline">
          <strong><span
            style="font-size:18px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266">十、不可抗力</span></strong>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">对于因一链网合理控制范围以外的原因，包括但不限于自然灾害、罢工或骚乱、物质短缺或定量配给、暴动、战争行为、政府行为、通讯或其他设施故障或严重伤亡事故等，致使一链网延迟或未能履约的，一链网不对您承担任何责任。</span>
        </p>
        <p
          style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0;text-align:left;line-height:30px;background:white;vertical-align: baseline">
          <strong><span style="font-size:18px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266">十一、法律适用、管辖及其他</span></strong>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">1</span><span
          style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">、本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国大陆地区法律，如无相关法律规定的，则应参照通用国际商业惯例和（或）行业惯例。</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">2</span><span
          style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">、您与一链网仅为独立订约人关系。本协议无意结成或创设任何代理、合伙、合营、雇佣与被雇佣或特性授权与被授权关系。</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">3</span><span
          style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">、您同意一链网因经营业务需要有权将本协议项下的权力义务就部分或全部进行转让，而无须再通知予您并取得您的同意。</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">4</span><span
          style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">、因本协议或一链网服务所引起或与其有关的任何争议应向一链网所属的上海一链企业管理有限公司住所地有管辖权的人民法院提起诉讼。</span>
        </p>
        <p
          style="margin-bottom:10px;text-align:left;text-indent:32px;line-height:26px;background: white;vertical-align:baseline">
          <span
            style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">5</span><span
          style="font-size:16px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;letter-spacing:2px">、本协议取代您和一链网先前就相同事项订立的任何书面或口头协议。倘若本协议任何条款被裁定为无效或不可强制执行，该项条款应被撤销，而其余条款应予遵守和执行。条款标题仅为方便参阅而设，并不以任何方式界定、限制、解释或描述该条款的范围或限度。一链网未就您或其他人士的某项违约行为采取行动，并不表明一链网撤回就任何继后或类似的违约事件采取动的权利。</span>
        </p>
        <p>
          <span
            style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#606266;border:none windowtext 1px;padding:0;background:white">注：未经允许，抄袭、模仿和传播一链网站提供的产品、服务和功能，一经发现，一链网有权要求您赔偿，并有权立即停止提供服务！</span>
        </p>
        <p>
          <br/>
        </p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="operateUser(true)">同 意</el-button>
        <el-button @click="operateUser(false)">不同意</el-button>
      </div>
    </el-dialog>

    <el-dialog title="一链网平台隐私政策" :visible.sync="privacyPolicyVisible" custom-class="registerDialog">
      <!-- <div id="alert-box2" class="alert-box layui-layer-wrap" style="display: block;">
        <p>我们非常重视您的隐私，保护用户隐私是一链网的重点原则，在您使用一链网提供的服务前，请您仔细阅读以下隐私保护原则。</p>
        <h5>一、用户信息</h5>
        <p>一链网将对您所提供的资料进行严格的管理及保护，通过技术手段、提供隐私保护服务功能，充分保护用户的个人资料安全。一链网保证不对外公开或向第三方提供用户注册的资料、及用户在使用服务时存储的非公开内容，但下列情况除外：</p>
        <p>1、事先获得您的明确授权；</p>
        <p>2、根据相关的法律法规要求；</p>
        <p>3、按照相关司法机构或政府主管部门的要求；</p>
        <p>4、只有透露您的个人资料，才能提供您所要求的产品的和服务；</p>
        <p>5、因黑客行为或用户的保管疏忽导致账号、密码遭他人非法使用；</p>
        <p>6、由于您将用户密码告知他人或与他人共享注册账户，由此导致的任何信息泄露；</p>
        <h5>二、第三方合作伙伴</h5>
        <p>一链网选择有信誉的第三方公司或产品作为我们的合作伙伴为用户提供信息和服务。尽管我们只选择有信誉的公司或产品作为我们的合作伙伴，但是每个合作伙伴都会有与一链网不同的隐私保护政策，一旦您使用了第三方合作伙伴的服务或产品，一链网隐私策略将不再生效，我们建议您查看该合作伙伴网站的隐私策略，并了解该合作伙伴对于收集、使用、泄露您的个人信息的规定。
        </p>
        <p>我们不会将您在访问和使用一链网网站以及相关服务时提交的信息如姓名、地址、电子邮件地址以及电话号码等直接透露或公开给第三方个人或企业。根据需求，我们可能会将这些信息的统计结果与我们的合作伙伴共享。</p>
        <h5>三、隐私保护原则的变动</h5>
        <p>如果我们需要改变隐私策略,我们会把相关的改动在相关页面发布,以便您能随时了解我们的隐私策略。</p>
      </div> -->
      <!-- <div slot="title" style="height:50px;margin-top:50px;text-align:left;font-weight:600;">
        <p>尊敬的一链网用户：</p>
        <p style="text-indent: 2em;">一链网自2020年1月7日更新《一链网隐私策略》，请您仔细阅读后并点击【同意】继续操作，以下为《一链网隐私策略》内容：</p>
      </div> -->
      <div id="alert-box1" class="alert-box layui-layer-wrap" style="display: block;max-height: 440px">
        <p
          style="margin-top:0;margin-right:5px;margin-bottom:0;margin-left:0;margin-bottom:0;text-align:right;line-height:115%;background:white">
          <span style="font-size:13px;line-height:115%;font-family: Symbol;color:#595959">·<span
            style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><strong><span
          style="font-size:16px;line-height: 115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">发布日期：2021年12月22日</span></strong>
        </p>
        <p style="margin-right:5px;text-align:right;line-height:115%;background:white">
          <strong><span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">生效时间：2021年12月30日</span></strong>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <strong><span
            style="font-size:16px;line-height: 115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">引言</span></strong>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">欢迎您访问一链网平台！一链网（以下也称“我们”）深知个人信息对您的重要性，因此我们非常重视保护您的隐私和个人信息。我们将按照法律法规要求并通过《一链网平台隐私政策》（以下简称“本政策”）向您说明我们在您使用一链网平台的产品/服务时如何处理您的个人信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式。</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">&nbsp;</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">【特别提示】在您使用一链网平台的产品/服务之前，请您务必仔细阅读、充分理解本政策，特别是以字体加粗的条款，您应当重点阅读，在确认充分理解并同意后开始使用一链网平台的产品/服务。如果您或您的监护人（如果您是未成年人）不同意本政策的任何内容，您可以使用一链网平台的搜索、浏览功能，但您将无法使用一链网平台的产品/服务。如对本政策内容有任何疑问、意见或建议，您可通过本政策第九条提供的联系方式与我们联系。</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">请您特别注意本政策的适用范围：</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">1</span><span
          style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">、本政策适用于一链网平台提供的所有产品和服务。如我们及关联公司的产品/服务中使用了一链网平台提供的产品/服务但未设独立隐私政策的，则该部分产品/服务同样适用于本政策。如我们及关联公司的产品/服务已设独立隐私政策的，则独立的隐私政策优先适用，该等独立的隐私政策中未提及而本政策有约定的内容，适用本政策。</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">2</span><span
          style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">、本政策不适用于一链网平台的产品/服务中包含的或链接至第三方提供的信息/服务（包括任何第三方应用、网站等），该等信息/服务由第三方负责运营，须遵循该第三方的隐私政策或类似规定。</span>
        </p>
        <p
          style="margin-top:0;margin-right:5px;margin-bottom: 0;margin-left:0;margin-bottom:0;line-height:115%;background:white">
          <span style="font-size:13px;line-height:115%;font-family:Symbol;color:#595959">·<span
            style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><strong><span
          style="font-size:16px;line-height: 115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">第一部分 定义</span></strong>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">1</span><span
          style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">、一链网平台：一链网平台客户端（包括但不限于PC页面、H5页面或微信公众号），客户端适用的终端设备包括但不限于PC、平板电脑、手机。</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">2</span><span
          style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">、一链网 /我们：指一链网平台的开发者和运营者上海一链企业管理有限公司（注册地址为上海市崇明区新河镇新开河路825号8幢C区118室）。</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">3</span><span
          style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">、关联公司：指上海一链企业管理有限公司披露的关联方企业。</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">4</span><span
          style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">、用户/您：访问或使用一链网平台所提供的产品/服务的自然人，包括注册用户及未注册用户。</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">5</span><span
          style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">、个人信息：以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息。</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">6</span><span
          style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">、敏感个人信息：一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。本政策中涉及的敏感个人信息包括个人身份信息、个人提交的企业信息、个人提交的业务信息、生物识别、金融账户、行踪轨迹、操作日志等信息。</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">7</span><span
          style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">、个人信息删除：在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">8</span><span
          style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">、未成年人：不满十八周岁的自然人为未成年人。十六周岁以上的未成年人，以自己的劳动收入为主要生活来源的，视为完全民事行为能力人。</span>
        </p>
        <p
          style="margin-top:0;margin-right:5px;margin-bottom: 0;margin-left:0;margin-bottom:0;line-height:115%;background:white">
          <span style="font-size:13px;line-height:115%;font-family:Symbol;color:#595959">·<span
            style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><strong><span
          style="font-size:16px;line-height: 115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">第二部分 隐私政策</span></strong>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">本政策将帮助您了解以下内容：</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">一、我们如何收集和使用您的个人信息</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">二、我们如何使用Cookie和同类技术</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">三、我们如何共享、转移、委托处理和公开披露您的个人信息</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">四、我们如何存储和跨境传输您的个人信息</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">五、我们如何保护您的个人信息安全</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">六、我们如何保护未成年人的个人信息</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">七、您如何行使您的个人信息权利</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">八、本政策的修订和通知</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">九、如何联系我们</span>
        </p>
        <p
          style="margin-top:0;margin-right:5px;margin-bottom: 0;margin-left:0;margin-bottom:0;line-height:115%;background:white">
          <span style="font-size:13px;line-height:115%;font-family:Symbol;color:#595959">·<span
            style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><strong><span
          style="font-size:16px;line-height: 115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">一、我们如何收集和使用您的个人信息</span></strong>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">在您使用我们的产品/服务时，您需要/可以选择授权我们收集和使用个人信息的情形包括：</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">1</span><span
          style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">、为了向您提供我们产品/服务的基本功能，您需要授权我们收集、使用必要信息的情形。如您拒绝提供前述必要信息，您将无法正常使用我们的产品/服务；</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">2</span><span
          style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">、为了向您提供我们产品/服务的附加功能，您可以选择授权我们收集、使用信息的情形。如您拒绝提供前述信息，您将无法正常使用相关附加功能或无法实现我们拟达到的功能效果，但并不会影响您正常使用我们产品/服务的基本功能。</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">请您注意，因我们向您提供的产品和服务种类众多，我们将根据您选择使用的具体产品/服务范围，遵循“合理、正当、必要”原则收集和使用您的个人信息。除此之外，您理解并同意，基于向您提供更好的产品和服务的目的，我们可能会不时推出新的或优化后的功能，可能增加或变更收集和使用个人信息的目的、范围和方式。对此，我们将通过更新本政策、弹窗或站内信等通知方式另行向您说明收集和使用对应信息的目的、范围和方式，并为您提供同意与否的选项，且在征得您的明示同意后收集、使用对应信息。在此过程中，如您有任何疑问、意见或建议，您可通过本政策第九条提供的联系方式与我们联系。</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <strong><span
            style="font-size:16px;line-height: 115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">（一）为您提供搜索、浏览功能</span></strong>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">通常情况下，您可以在同意隐私政策后且未登录状态在一链网平台上搜索和浏览各类产品。但请您理解，出于保护商业信息目的，详情页面上的部分详细信息可能需要您注册账户并登录后才可以进行浏览。</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">在您同意本政策后，为保障搜索、浏览、参与项目功能的实现，我们会收集您在网页输入的搜索关键字、您点击的页面或链接以便在一链网平台的服务端向您返回相应的页面或结果。此外，我们也会收集您的日志信息。</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">请您注意，单独的日志信息或仅搜索关键词信息无法单独识别您的身份，不属于您的个人信息，只有当您的单独的日志信息或搜索关键词信息与您的其他信息相互结合使用并可以识别您的身份时；则在结合使用期间，我们会将您的日志信息或搜索关键词信息作为您的个人信息，按照本政策对其进行处理与保护。</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <strong><span
            style="font-size:16px;line-height: 115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">（二）帮助您注册与管理一链网账户</span></strong>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">1</span><span
          style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">、账户注册<br/> 若您想使用一链网平台的产品/服务，您首先需要注册一个一链网账户成为一链网平台的用户。注册时，您至少需提供手机号（用于接收短信验证码）并设置密码用以创建一链网账户。如您拒绝提供手机号，您将无法在一链网平台创建账户并使用一链网平台的产品/服务，但不影响您正常使用一链网平台的搜索、浏览功能。<br/> 为了确保我们是在为您本人提供服务，我们需要您完成实人认证：您可以根据认证要求提供相应的&nbsp;身份信息（身份证、护照、港澳居民来往内地通行证、台湾居民来往大陆通行证、外国人永久居留证及其他身份证件信息）&nbsp;以完成实名认证，我们可能会根据您提供的上述信息校验您的身份。</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">为了确保您注册认证的公司已经获得相应的公司授权，我们需要您提交相应的公司授权说明函，以确保您可以代表该公司注册一链网账户。您理解并同意，您使用一链网账户登录后在一链网平台的一切行为均代表您本人及您公司。您的一链网账户操作所产生的电子信息记录均为您行为的有效凭据，并由您本人及您公司承担由此产生的全部责任。</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">2</span><span
          style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">、账户登录<br/> 若您选择通过第三方账户（包括微信、支付宝、CA数字证书等）登录一链网平台，在您同意本政策后，我们将从第三方获取您授权共享的第三方账户信息（头像、昵称及您在页面授权的其他个人信息），并将您的第三方账户与您的一链网账户绑定，使您可以通过第三方账户直接登录并使用我们的服务。我们会依据与第三方的约定，在符合相关法规的前提下，使用您的个人信息。<br/> 请您注意，在您首次使用第三方账户登录一链网平台（包括解绑第三方账户后的首次登录）的情形下，为确保符合法律法规的要求，保护您的账户安全，我们仍会要求您提供手机号，以验证您的真实身份。同时，我们会根据您提供的手机号实现第三方账户与一链网账户的绑定。</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <strong><span
            style="font-size:16px;line-height: 115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">（三）为您提供产品/服务信息的推送</span></strong>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">为向您推荐您可能感兴趣的产品/服务信息，我们会通过站内信，或通过您提供的电子邮件地址、手机号、通信地址等向您发送商业信息，推送信息包括不限于最新的一链网产品信息、促销信息、项目信息等。</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <strong><span
            style="font-size:16px;line-height: 115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">（四）为您提供收藏、关注与分享功能</span></strong>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">在您使用一链网平台的产品/服务过程中，您可以选择对感兴趣的产品/服务/项目进行收藏，也可以通过一链网平台的功能组件向第三方进行信息分享，我们至少需要收集您在收藏、关注与分享过程中产生的日志信息，用于实现上述功能以及其他我们明确告知的目的。</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <strong><span
            style="font-size:16px;line-height: 115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">（五）为您提供招标采购管理功能</span></strong>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">当您使用一链网平台参与平台上的采购项目时（包括但不限于公开招标采购、邀请招标采购、公开询比采购、邀请询比采购、直委采购等），为了确保您能够顺利参与整个项目，我们会收集您在项目过程中提交的所有资料信息，包括报名资料、投标文件、报价文件等，以及您在操作过程中产生的日志信息。</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <strong><span
            style="font-size:16px;line-height: 115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">（六）帮助向您完成产品/服务的交付</span></strong>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">在参与采购项目过程中，我们为您提供各类增值付费服务项目，包括但不限于征信报告、电子保函、CA数字证书等。</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">为向您完成产品/服务的交付，我们在此过程中至少需要收集和使用您的订单信息以保证您的订购的产品/服务能够安全完成交付。<br/> 若您购买的产品/服务需要使用邮寄（发票、商品）服务的，您至少需要提供产品/服务的使用人或收件人的姓名、手机号，视产品不同可能还需要您提供配送地址、电子邮箱地址，以便您的发票、产品/服务能够送达。<br/> 若您就购买的产品/服务需要开具纸质或电子发票的，我们至少需要收集发票抬头、邮箱在内的开票信息以及上述配送信息。</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <strong><span
            style="font-size:16px;line-height: 115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">（七）为您提供客户服务与处理争议</span></strong>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">为保证您的账户安全，我们的电话客服和在线客服会使用您的用户资料、订单信息和项目信息，以验证您的身份。当您主动要求我们提供与您订单或者项目相关的客户服务时，我们可能会查询您的相关订单信息或项目信息以便给予您适当的帮助和处理。如您主动要求客服协助您修改有关信息（如公司信息、项目信息、联系人或联系电话），您可能还需要提供上述信息外的其他信息以便完成修改。<br/> 当您与我们联系时，我们可能会保存与您的通信/通话记录和内容，或您留下的联系方式及相关信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。上述录音在被保留法律规定的最短必要时间后会自动删除，除非由于合规要求或合法利益需要而保留。</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <strong><span
            style="font-size:16px;line-height: 115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">（八）改进一链网平台的产品/服务</span></strong>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">1</span><span
          style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">、我们可能会对收集的信息进行去标识化地研究、统计分析和预测，用于改善一链网平台的内容和布局，为商业决策提供产品或服务支撑，以及改进我们的产品和服务。<br/> 2、我们可能将您的项目数据、订单数据用于数据分析，以便让我们能够了解您所在的位置、喜好或与其他来源（包括第三方）的数据相匹配，从而开发和改进我们的产品和服务。<br/> 3、我们可能会通过您提供的联系方式邀请您参与市场调查，并基于您参加市场调查所提供的信息，分析、衡量您对我们的产品、服务和网站的兴趣，从而开发和改进我们的产品和服务。如您选择不参与市场调查并提供有关信息（以具体市场调查展示页面为准），不会影响您使用一链网平台的基本功能。</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <strong><span
            style="font-size:16px;line-height: 115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">（九）收集和使用您的个人信息的特别说明</span></strong>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">1</span><span
          style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">、若我们将信息用于本政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的，均会重新获得您的授权同意。<br/> 2、征得授权同意的例外<br/> 您充分知晓，根据法律法规要求，以下情形中我们收集、使用您的个人信息无需征得您的授权同意：<br/> 1）为履行一链网法定职责或者法定义务所必需；<br/> 2）与国家安全、国防安全有关的；<br/> 3）与公共安全、公共卫生、重大公共利益有关的；<br/> 4）与犯罪侦查、起诉、审判和判决执行等有关的；<br/> 5）为订立、履行您作为一方当事人的合同所必需；<br/> 6）在紧急状况下，出于维护您或其他个人的生命健康和财产安全；<br/> 7）所收集的个人信息是个人信息主体自行向社会公众公开的或其他已经合法公开的个人信息；<br/> 8）从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；<br/> 9）为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；<br/> 10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；<br/> 11）法律法规以及国家标准规定的其他情形。<br/> 请知悉，根据适用的法律，若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，则此类处理后数据的使用无需另行向您通知并征得您的同意。</span>
        </p>
        <p
          style="margin-top:0;margin-right:5px;margin-bottom: 0;margin-left:0;margin-bottom:0;line-height:115%;background:white">
          <span style="font-size:13px;line-height:115%;font-family:Symbol;color:#595959">·<span
            style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><strong><span
          style="font-size:16px;line-height: 115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">二、我们如何使用Cookie和同类技术</span></strong>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">为了让您获得更轻松便捷的访问体验，您访问一链网平台或使用我们提供的服务时，我们可能会在您的设备终端或系统上存储名为Cookie的小型数据文件用来识别您的身份，这样可以帮您省去重复输入注册信息的步骤，帮您优化对广告的选择与互动及其帮助判断您的账户安全状态。您可以清除计算机或移动设备上保存的所有 Cookie，您有权接受或拒绝Cookie，如果浏览器自动接受Cookie，您可以根据自己的需要修改浏览器的设置以拒绝Cookie。请注意，如果您选择拒绝Cookie，那么您可能无法更好地体验我们提供的服务。</span>
        </p>
        <p
          style="margin-top:0;margin-right:5px;margin-bottom: 0;margin-left:0;margin-bottom:0;line-height:115%;background:white">
          <span style="font-size:13px;line-height:115%;font-family:Symbol;color:#595959">·<span
            style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><strong><span
          style="font-size:16px;line-height: 115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">三、我们如何共享、转移、委托处理和公开披露您的个人信息</span></strong>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <strong><span
            style="font-size:16px;line-height: 115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">（一）共享与提供</span></strong>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">1</span><span
          style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">、处理原则<br/> 我们可能会向合作伙伴等第三方共享您的订单信息、账户信息、设备信息以及位置信息，以保障为您提供的服务顺利完成。但我们仅会出于合法、正当、必要、特定、诚信、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们将评估第三方收集您的个人信息的合法性、正当性、必要性，同时，要求第三方在您的授权同意范围内处理您的个人信息，采取必要的信息管理措施与技术手段，防止您的个人信息发生泄露、损毁、丢失、篡改等后果。第三方无权将所共享的您的个人信息用于任何其他用途，如要改变个人信息的处理目的、处理方式的，将重新获得您的授权同意。<br/> 2、单独同意<br/> 除非符合征得授权同意的例外情形（见本政策“一、我们如何收集和使用您的个人信息”），否则我们将会按照法律法规及国家标准的要求，针对除前述情形之外的某些场景下的个人信息的共享与提供，采取合理的方式另外征得您的单独同意。但不论是否需要征得您的单独同意，我们均会以合理的方式向您明示告知具体向您提供所涉产品/服务的第三方供应商信息及其处理您个人信息的目的、方式和种类，例如，在您准备订购部分一链网平台的产品/服务时，我们可能会在您下单前通过订单填写页面或订单确认页面向您明示告知上述信息，并在必要时征得您授权一链网向供应商或服务商提供您的个人信息的单独同意。具体的单独同意形式，请以具体产品/服务订单页面为准。<br/> 3、我们的合作伙伴包括以下类型（包含中国境内和中国境外实体）：（1）金融机构和第三方支付机构：当您预订订单、申请退款、购买保险时，我们会与金融机构或第三方支付机构共享特定的订单信息，当我们认为用于欺诈检测和预防目的实属必要时，我们将进一步和相关金融机构共享其他必要信息，如IP地址等。（2）业务合作伙伴：我们可能与合作伙伴一起为您提供产品或者服务，将向合作伙伴共享相关个人信息，用于包括快递业务、通讯服务、客户服务、市场推广、广告投放、技术服务、实名认证服务、咨询服务等。（3）关联公司：我们可能会与我们的关联公司共享您的相关个人信息，使我们能够向您提供与采招相关的或者其他产品或服务，他们会采取不低于本政策同等严格的保护措施。<br/> 请您注意，基于业务合作伙伴和关联公司防范和检测欺诈的目的，我们可能也会审慎地提供您的必要个人信息，这些个人信息的提供会经过严格的内部安全评估和审批并通过签署相应的协议限定这些信息的使用目的。</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <strong><span
            style="font-size:16px;line-height: 115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">（二）信息转移</span></strong>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">我们不会将您的个人信息转移给任何公司、组织和个人，但以下情况除外：<br/> （1）事先获得您的明确同意或授权；<br/> （2）根据适用的法律法规、法律程序的要求、强制性的行政或司法要求；<br/> （3）在涉及合并、分立、收购、资产转让或类似的交易时，如涉及到个人信息转移，我们会在正式进行信息转移前，向您告知接收信息公司、组织的名称和联系方式，并要求新的持有您个人信息的公司、组织继续受本政策的约束，继续履行原先由我们承担的个人信息处理义务。否则,我们将要求该公司、组织重新向您征求授权同意。</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <strong><span
            style="font-size:16px;line-height: 115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">（三）委托处理</span></strong>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">为了提升信息处理效率，降低信息处理成本或提高信息处理准确性，我们可能会委托有专业技术能力的关联公司或一链网以外的外部服务供应商处理您的个人信息。我们会与受托方签署委托处理协议，并要求受托方按照委托处理协议、本政策以及其他任何相关的保密和安全措施来处理个人信息。委托关系不生效、无效或被撤销或者终止时，我们会要求受托方返还、删除您的个人信息(包括但不限于因委托处理获取到的原始信息或副本、摘要等)，不得保留。未经您的授权同意，我们禁止受托方转委托他人处理您的个人信息。</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <strong><span
            style="font-size:16px;line-height: 115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">（四）公开披露</span></strong>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">我们仅会在以下情形，公开披露您的个人信息：<br/> （1）根据您的需求，在您单独同意的前提下，根据您认可的披露方式下披露您所指定的个人信息；<br/> （2）根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。</span>
        </p>
        <p
          style="margin-top:0;margin-right:5px;margin-bottom: 0;margin-left:0;margin-bottom:0;line-height:115%;background:white">
          <span style="font-size:13px;line-height:115%;font-family:Symbol;color:#595959">·<span
            style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><strong><span
          style="font-size:16px;line-height: 115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">四、我们如何存储您的个人信息</span></strong>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <strong><span
            style="font-size:16px;line-height: 115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">（一）存储地点</span></strong>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">1</span><span
          style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">、处理原则<br/> 我们会按照法律法规规定，将中华人民共和国境内收集的用户个人信息存储于中国境内。<br/> 2、跨境传输<br/> 如果您的个人信息存储地点从中国境内转移到境外的，我们将严格依照法律的规定执行。<br/> 需要将您的个人信息传输至境外的场景包括：<br/> （1）获得您的明确授权；<br/> （2）当采招服务涉及到境外服务提供商时；<br/> （3）法律法规的明确要求。<br/> 除非符合征得授权同意的例外情形（见本政策“一、我们如何收集和使用您的个人信息”），否则我们将会按照法律法规及国家标准的要求，针对除前述情形之外的个人信息跨境传输情形，采取合理的方式另外征得您的单独同意。但不论是否需要征得您的单独同意，我们均会以合理的方式向您明示告知所涉产品/服务的境内外服务商信息及其处理您个人信息的目的、方式和种类，我们将按照法律、行政法规和国家网信主管部门规定（如履行安全评估义务、个人信息保护认证、按照主管部门制定的标准合同与境外接收方签订协议）条件执行，并要求境外机构对所获得的您的个人信息保密并履行相应的个人信息保护义务。</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <strong><span
            style="font-size:16px;line-height: 115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">（二）存储期限</span></strong>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">我们仅在本政策所述目的所必需且最短的期间内，或法律法规要求的时限内保留您的信息。例如，当您使用一链网平台的注册功能时，我们需要收集您的手机号，且在您提供后并在您使用该功能期间，我们需要持续为您保留您的手机号，以向您正常提供该功能、保障您的账户和系统安全。在超出上述存储期限后，或在您行使个人信息删除权、注销账户的情况下，我们会对您的个人信息进行删除或匿名化处理。<br/> 但在下列情况下，我们有可能因需符合法律要求，调整个人信息的存储时间：<br/> （1）为遵守适用的法律法规等有关规定；<br/> （2）为遵守法院判决、裁定或其他法律程序的规定；<br/> （3）为遵守相关政府机关或法定授权组织的要求；<br/> （4）为维护社会公共利益，为保护一链网平台的用户、我们或我们的关联公司、其他用户或雇员的人身财产安全或其他合法权益所合理必需的用途。</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <strong><span
            style="font-size:16px;line-height: 115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">（三）停止运营</span></strong>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">如我们停止运营一链网平台产品或服务，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，对所持有的个人信息进行删除或匿名化处理。</span>
        </p>
        <p
          style="margin-top:0;margin-right:5px;margin-bottom: 0;margin-left:0;margin-bottom:0;line-height:115%;background:white">
          <span style="font-size:13px;line-height:115%;font-family:Symbol;color:#595959">·<span
            style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><strong><span
          style="font-size:16px;line-height: 115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">五、我们如何保护您的个人信息安全</span></strong>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">1</span><span
          style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">、一链网非常重视信息安全，成立了专门的负责团队，负责对个人信息处理活动以及采取的保护措施进行监督。 我们努力为您提供信息保护，采取了合适的管理、技术以及物理安全措施，参照国内外信息安全标准及最佳实践建立了与业务发展相适应的信息安全保障体系。<br/> 2、我们从数据的生命周期角度出发，在数据收集、存储、显示、处理、使用、销毁等各个环节建立了安全防护措施，根据信息敏感程度的级别采取不同的控制措施，包括但不限于访问控制、SSL加密传输、AES或以上强度的加密算法进行加密存储、敏感信息脱敏显示等。<br/> 3、我们对可能接触到您信息的员工也采取了严格管理，可监控他们的操作情况，对于数据访问、内外部传输使用、脱敏、解密等重要操作建立了审批机制，并与上述员工签署保密协议等。与此同时，我们还定期对员工进行信息安全培训，要求员工在日常工作中形成良好操作习惯，提升数据保护意识。<br/> 4、尽管有前述的安全措施，但同时也请您理解在网络上不存在“完善的安全措施”。我们会按现有的技术提供相应的安全措施来保护您的信息，提供合理的安全保障，我们将尽力做到使您的信息不被泄露、损毁或丢失。<br/> 5、您的账户均有安全保护功能，请妥善保管您用于登录一链网平台的设备以及您的账户名及验证码信息，切勿将设备提供他人用于登录一链网平台或将验证码告知他人，如果您发现自己的个人信息泄露，特别是您的账户名和验证码发生泄露，请您立即与我们的客服联系，以便我们采取相应的措施。<br/> 6、请您及时保存或备份您的文字、图片等其他信息，您需理解并接受，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。<br/> 7、在使用一链网平台服务进行网上操作时，请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。我们将尽力保障您发送给我们的任何信息的安全性。为防止他人未经授权使用您的验证码或使用您的计算机、移动设备或SIM卡，如您发现自己的个人信息尤其是您的账户或验证码发生泄露，请您立即联络一链网平台客服，以便我们核实后根据您的申请采取相应措施。<br/> 8、在不幸发生个人信息安全事件后，我们将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。</span>
        </p>
        <p
          style="margin-top:0;margin-right:5px;margin-bottom: 0;margin-left:0;margin-bottom:0;line-height:115%;background:white">
          <span style="font-size:13px;line-height:115%;font-family:Symbol;color:#595959">·<span
            style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><strong><span
          style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">&nbsp;&nbsp;</span></strong><strong><span
          style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">六、我们如何保护未成年人的个人信息</span></strong>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">1</span><span
          style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">、一链网非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用我们的服务前，应事先取得您法定监护人的同意。我们根据《中华人民共和国未成年人保护法》等国家相关法律法规的要求对未成年人的个人信息及隐私进行保护。<br/> 2、一链网不会主动直接向未成年人收集其个人信息。对于经监护人同意而收集未成年人个人信息的情况，我们仅在法律法规允许、监护人同意或保护未成年人所必要的情况下使用、共享、转移或披露此类信息。<br/> 3、如果有事实证明未成年人并未取得监护人同意的情况下注册和使用了我们的服务，监护人可以联系一链网平台客服，我们会在确认后尽快删除相关未成年人的个人信息。</span>
        </p>
        <p
          style="margin-top:0;margin-right:5px;margin-bottom: 0;margin-left:0;margin-bottom:0;line-height:115%;background:white">
          <span style="font-size:13px;line-height:115%;font-family:Symbol;color:#595959">·<span
            style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>
          <strong>
            <span
              style="font-size:16px;line-height: 115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">七、您如何行使您的个人信息权利</span>
          </strong>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">您对您的个人信息享有以下权利：<br/> <strong>（一）个人信息的查询、更正、补充及管理</strong></span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">&nbsp;</span><span
          style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">在一链网PC端登录后，您可自行访问、更正、补充及管理您的个人信息。</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <strong><span
            style="font-size:16px;line-height: 115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">（二）个人信息的删除</span></strong>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">您可以通过“（一）个人信息的查询、更正、补充及管理”列明的部分路径删除您的部分信息。<br/> 同时，在下列情形中，您可以通过本政策第九条的联系方式与我们联系，向我们提出删除个人信息的请求，我们将在十五个工作日内回复您的请求：<br/> （1）如果我们处理个人信息的行为违反法律法规；<br/> （2）如果我们收集、使用您的个人信息，却未征得您的明确同意；<br/> （3）如果我们处理个人信息的行为严重违反了与您的约定；<br/> （4）如果您不再使用我们的产品或服务，或您主动注销了账户；<br/> （5）如果我们永久不再为您提供产品或服务。<br/> 当您或我们协助您删除相关信息后，因为适用的法律要求或安全技术原因，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并将其与任何进一步处理隔离，直至备份更新时可以清除这些信息或实现匿名。</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <strong><span
            style="font-size:16px;line-height: 115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">（三）改变您授权同意的范围或撤回授权</span></strong>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">您可以通过删除您的个人信息等方式改变您授权我们继续收集个人信息的范围或撤回您的授权。您也可以通过注销账户的方式，撤回我们继续收集您个人信息的全部授权。但请注意，每个业务功能需要一些基本的个人信息才能得以完成（见本政策“一、我们如何收集和使用您的个人信息”），当您撤回授权后，我们无法继续为您提供所对应的服务。同时，基于部分产品的特殊性和相关法律法规的要求，如果您使用的服务尚未结束，在服务结束之前您有可能无法撤回您的授权。<br/> 对于我们持续使用您的个人信息的数据处理行为，当您执行上述操作后，我们将不再处理相应的个人信息，但您的上述操作不会影响此前基于您的授权已经开展的个人信息处理。</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <strong><span
            style="font-size:16px;line-height: 115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">（四）注销您的账户</span></strong>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">您可联系一链网平台客服提交相应的资料申请注销一链网平台账户。注销一链网平台账户后，您该账户内的所有信息将被清空，我们将不会再收集、使用或共享与该账户相关的个人信息，但之前的信息我们仍需按照监管要求的时间进行保存，且在该依法保存的时间内有权机关仍有权依法查询。</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <strong><span
            style="font-size:16px;line-height: 115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">（五）获取个人信息副本</span></strong>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">如您需要您的个人信息的副本，您可以通过本政策第九条的联系方式与我们联系，在核实您的身份后，我们将向您提供您在我们的服务中的个人信息副本（包括基本资料、身份信息），但法律法规另有规定的或本政策另有约定的除外。</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <strong><span
            style="font-size:16px;line-height: 115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">（六）响应您的请求</span></strong>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">如果您无法通过上述方式访问、更正、补充或删除您的个人信息，或您需要访问、更正、补充或删除您在使用我们产品/服务时所产生的其他个人信息，或您需要获取您的个人信息副本，或您认为我们存在任何违反法律法规或与您关于个人信息的收集或使用的约定，您均可以通过本政策第九条的联系方式与我们联系。<br/> 为了保障安全，我们可能需要您提供书面请求，或提供您的身份证明文件，我们将在收到您反馈并验证您的身份后的十五个工作日内答复您的请求。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份服务器上存放的信息）的请求，我们可能会予以拒绝。<br/> 在以下情形中，按照法律法规要求，我们将无法响应您的请求：<br/> （1）与一链网履行法律法规规定的义务相关的；<br/> （2）与国家安全、国防安全有关的；<br/> （3）与公共安全、公共卫生、重大公共利益有关的；<br/> （3）与公共安全、公共卫生、重大公共利益有关的；<br/> （4）与犯罪侦查、起诉和审判和执行判决等有关的；<br/> （5）有充分证据表明您存在主观恶意或滥用权利的；<br/> （6）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；<br/> （7）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；<br/> （8）涉及商业秘密的。</span>
        </p>
        <p
          style="margin-top:0;margin-right:5px;margin-bottom: 0;margin-left:0;margin-bottom:0;line-height:115%;background:white">
          <span style="font-size:13px;line-height:115%;font-family:Symbol;color:#595959">·<span
            style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><strong><span
          style="font-size:16px;line-height: 115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">八、本政策的修订和通知</span></strong>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">我们会在必要时修改一链网隐私政策，请您理解，我们可能会适时修订本政策，我们将标注本政策最近更新的日期，并经公示后生效。未经您明确同意，我们不会削减您按照本政策所应享有的权利。对于重大变更，我们还会提供更为显著的通知（包括对于某些服务，我们会通过电子邮件发送通知，说明隐私政策的具体变更内容）。请您经常回访本政策，以阅读最新版本。<br/> 本政策所指的重大变更包括但不限于：<br/> 1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；<br/> 2、我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；<br/> 3、个人信息共享、转移或公开披露的主要对象发生变化；<br/> 4、您参与个人信息处理方面的权利及其行使方式发生重大变化；<br/> 5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；<br/> 6、个人信息安全影响评估报告表明存在高风险时。</span>
        </p>
        <p
          style="margin-top:0;margin-right:5px;margin-bottom: 0;margin-left:0;margin-bottom:0;line-height:115%;background:white">
          <span style="font-size:13px;line-height:115%;font-family:Symbol;color:#595959">·<span
            style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><strong><span
          style="font-size:16px;line-height: 115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">九、如何联系我们</span></strong>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">1</span><span
          style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">、如您对本隐私政策或您个人信息的相关事宜有任何问题、意见或建议，您可以通过访问一链网首页，点击右侧客服图标按钮，访问在线客服系统；或通过发送邮件至exonelink@wbpharma.com；或拨打0516-87796393客服热线等多种方式与我们联系。<br/> 2、一般情况下，我们将在十五天内回复。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以通过向被告住所地有管辖权的法院提起诉讼来寻求解决方案。</span>
        </p>
        <p style="margin-right:5px;line-height:115%;background:white">
          <span
            style="font-size:16px;line-height:115%;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#595959">&nbsp;</span>
        </p>
        <p>
          <br/>
        </p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="operatePrivacy(true)">同 意</el-button>
        <el-button @click="operatePrivacy(false)">不同意</el-button>
      </div>
    </el-dialog>

    <v-footer :webConfigInfo='webConfigInfo' :footerColumnInfos='footerColumnInfos'></v-footer>
    <v-backToTop></v-backToTop>
  </div>
</template>
<script>
import header from '@/components/v-header/header'
import topBar from '@/components/topBar'
import registerTop from '@/components/registerTop'
import footer from '@/components/v-footer'
import backToTop from '@/components/backToTop'
import {mapState} from 'vuex'
import {customUserIdentitySelect} from '@/assets/js/sensors'

export default {
  props: [],
  data() {
    var checkCompanyName = (rule, value, callback) => {
      if (value == '' && this.ruleForm.regAddrType == '0') {
        return callback(new Error('请输入企业名称'));
      } else {
        return callback();
      }
    };
    var checkLienceCode = (rule, value, callback) => {
      if (value == '' && this.ruleForm.regAddrType == '1') {
        return callback(new Error('注册证明未填写。请完整填写后继续'));
      } else {
        return callback();
      }
    };
    return {
      isSpeciaCo: false,//是否是特殊企业，true为是，false为不是
      disabledFlag: true,
      searchVagueCompany: '',
      userAgreementVisible: false,
      privacyPolicyVisible: false,
      centerDialogVisible: false,
      navigationColumnInfos: [],
      footerColumnInfos: [],
      webConfigInfo: {},
      messageData: [],
      messageTotal: 0,
      currentPage: 1,
      searchDis: true,
      checkList: [],
      abroadShow: false,
      fileTypeFlag: true,
      navTitle: '注册',
      selectAddrType: '',
      ruleForm: {
        companyName: '',
        orgIdentity: '',
        regAddrType: '0',
        licenceCode: ''
      },
      rules: {
        companyName: [
          {required: true, validator: checkCompanyName, trigger: 'blur'}
        ],
        licenceCode: [
          {required: true, validator: checkLienceCode, trigger: 'blur'}
        ],
        regAddrType: [
          {required: true, message: '请选择境内外供应商', trigger: 'change'}
        ]
      },
      companyData: [],
      companySearch: '',
      userChecked: false,
      privacyChecked: false,
      findCreditFlag: false,
      selectCompanyName: '',
      selectCompanyId: '',
      regeisterInfo: {},
      companyInfo: {},
      hitSearchUrl: '',
      enterpriseResourceBaseUrl: '',
      yellowPageColumn: {},
      productAndSolutionColumn: {},
      companyListShow: false,
      registerShowBox: true,
      currentLienceCode: '',
      registeInviteCode: '',  // 邀请码
    }
  },
  watch: {
    ruleForm: {
      handler(newName, oldName) {
        if (newName.companyName == '') {
          this.searchDis = true
        } else {
          this.searchDis = false
        }
      },
      deep: true
    },
    userChecked(val) {
      if (this.ruleForm.regAddrType == '0') {
        if (val == true && this.privacyChecked == true && this.findCreditFlag == true) {
          this.disabledFlag = false;
        } else {
          this.disabledFlag = true;
        }
      } else {
        if (val == true && this.privacyChecked == true) {
          this.disabledFlag = false;
        } else {
          this.disabledFlag = true;
        }
      }

    },
    privacyChecked(val) {
      if (this.ruleForm.regAddrType == '0') {
        if (this.userChecked == true && val == true && this.findCreditFlag == true) {
          this.disabledFlag = false;
        } else {
          this.disabledFlag = true;
        }
      } else {
        if (this.userChecked == true && val == true) {
          this.disabledFlag = false;
        } else {
          this.disabledFlag = true;
        }
      }
    },
    findCreditFlag(val) {
      if (this.ruleForm.regAddrType == '0') {
        if (this.userChecked == true && val == true && this.findCreditFlag == true) {
          this.disabledFlag = false;
        } else {
          this.disabledFlag = true;
        }
      } else {
        if (this.userChecked == true && val == true) {
          this.disabledFlag = false;
        } else {
          this.disabledFlag = true;
        }
      }
    }
  },

  computed: mapState([
    'KP'
  ]),
  components: {
    'v-header': header,
    'v-topBar': topBar,
    'v-registerTop': registerTop,
    'v-footer': footer,
    'v-backToTop': backToTop
  },
  created() {
    this.$axios.post('/onelink.mdata.main.api/mainInfo/findMainCommonInfo', {}).then((res) => {
      this.data = res.data;
      this.webConfigInfo = this.data.webConfigInfoDto;
      this.footerColumnInfos = this.data.footerColumnInfos;
      this.navigationColumnInfos = this.data.navigationColumnInfos;
      this.yellowPageColumn = this.data.yellowPageColumn;
      this.productAndSolutionColumn = this.data.productAndSolutionColumn;
      this.hitSearchUrl = this.data.hitSearchUrl;
      this.enterpriseResourceBaseUrl = this.data.enterpriseResourceBaseUrl;
    }).catch((err) => {
      console.log(err)
    })
  },
  mounted() {
    this.registeInviteCode = this.$route.query.code || ''
    this.hideLise();
  },
  methods: {
    hideLise() {
      $('body').click(() => {
        this.companyListShow = false
      })
    },
    changeAddrType(value) {
      if (value == '0') {
        this.fileTypeFlag = true;
        this.ruleForm.regAddrType = '0';
        this.selectAddrType = '0';
      }
      if (value == '1') {
        this.fileTypeFlag = false;
        this.ruleForm.regAddrType = '1';
        this.selectAddrType = '1';
      }
      this.userChecked = false;
      this.privacyChecked = false;
      this.$refs['registerForm'].validate((valid) => {
      });

    },
    purchaserFn() {
      $('.purchaserBtn').addClass('active');
      $('.supplierBtn').removeClass('active');
      this.fileTypeFlag = true;
      this.selectAddrType = '0';
      this.abroadShow = false;
      this.ruleForm.orgIdentity = '20';
      this.ruleForm.regAddrType = '0';

    },
    supplierFn() {
      $('.supplierBtn').addClass('active');
      $('.purchaserBtn').removeClass('active');
      this.fileTypeFlag = true;
      this.selectAddrType = '0';
      this.abroadShow = true;
      this.ruleForm.orgIdentity = '10';
    },
    submitForm(formName) {
      this.userChecked = true;
      this.privacyChecked = true;
      if (this.ruleForm.orgIdentity == '') {
        this.$message({
          message: "请选择企业身份",
          type: 'error'
        });
        return false;
      }
      if (this.selectAddrType == '0' && this.ruleForm.companyName == '') {
        this.$message({
          message: "请输入企业名称",
          type: 'error'
        });
        return false;
      }
      if (this.selectAddrType == '1' && this.ruleForm.licenceCode == '') {
        this.$message({
          message: "注册证明未填写。请完整填写后继续",
          type: 'error'
        });
        return false;
      }
      this.$refs['registerForm'].validate((valid) => {
        if (valid) {
          if (this.ruleForm.regAddrType == '1') {
            this.currentLienceCode = this.ruleForm.licenceCode;
          }
          if (this.disabledFlag) {
            this.selectCompanyName = this.ruleForm.companyName;
          }

          try {
            let user_tag = this.ruleForm.orgIdentity == '20' ? '采购商' : '供应商'
            customUserIdentitySelect({user_type: user_tag})
          } catch (e) {
            console.log(e)
          }

          this.$axios.post('/onelink.mdata.main.api/company/findOrgInformationByLicenceOrName?orgName=' + encodeURI(this.selectCompanyName) + "&orgIdentity=" + this.ruleForm.orgIdentity + "&licenceCode=" + this.currentLienceCode + "&regAddrType=" + this.ruleForm.regAddrType, {}).then((res) => {
            this.data = res.data;
            let operateFlag = this.data.data.checkFlag;
            let creditCompanyName = this.data.data.companyName;
            if (operateFlag) {
              //企业名称在启信宝查询不到
              let companyExistFlag = this.data.data.companyExistFlag;
              if (!companyExistFlag) {
                this.$alert('<i class="el-icon-error" style="font-size: 32px;color: #F56C6C;position: absolute"></i><p style="padding-left: 48px">抱歉，没有找到相关结果！您可以:</p><p style="padding-left: 48px">1.输入准确的关键词，重新搜索</p><p style="padding-left: 48px">2.如果是非工商注册企业，请选择【境外及特殊企业】</p><p style="padding-left: 48px">3.点击屏幕右侧"咨询客服"与我们在线沟通。</p>', '', {
                  dangerouslyUseHTMLString: true
                });
                return false;
              }
              //校验企业身份
              let checkOrgIdentityFlag = this.data.data.checkOrgIdentityFlag;
              if (!checkOrgIdentityFlag) {
                this.$message({
                  message: this.data.data.errorInfo,
                  type: 'error'
                });
                return false;
              }
              this.companyInfo = this.data.data.companyInfo;
              // if(this.companyInfo.orgStatus == '20'){
              //   this.$message({
              //         message: "该企业正在审核中,暂时无法入驻新用户!",
              //         type: 'error'
              //   });
              //   return false;
              // }
              let currentTrueName = this.data.data.userInfo.trueName;
              let currentEmail = this.data.data.userInfo.email;
              // 保存企业审批核状态，企业注册人，注册邮箱
              this.regeisterInfo.orgStatus = this.companyInfo.orgStatus;
              this.regeisterInfo.currentTrueName = currentTrueName;
              this.regeisterInfo.currentEmail = currentEmail;
              // if(this.companyInfo.orgStatus == '25'){
              //   this.$message({
              //         message: "当前企业注册审核被驳回,请联系注册人"+currentTrueName+"("+currentEmail+")重新提交注册申请",
              //         type: 'error'
              //   });
              //   return false;
              // }
              this.regeisterInfo.companyName = creditCompanyName;
              this.regeisterInfo.orgIdentity = this.ruleForm.orgIdentity;
              this.regeisterInfo.regAddrType = this.ruleForm.regAddrType;
              this.regeisterInfo.companyId = this.companyInfo.id;
              if (this.ruleForm.regAddrType == '1') {
                this.regeisterInfo.companyName = this.companyInfo.orgName;
                this.regeisterInfo.licenceCode = this.ruleForm.licenceCode;
              } else if (this.ruleForm.regAddrType == '0') {
                this.regeisterInfo.licenceCode = this.companyInfo.licenceCode;
              }
              this.setToken("regeisterInfo", this.getAesString(JSON.stringify(this.regeisterInfo), this.KP.key, this.KP.iv));
              this.$router.push({path: '/registerExistBusinessInfo'})
            } else {
              this.regeisterInfo.companyName = creditCompanyName;
              this.regeisterInfo.orgIdentity = this.ruleForm.orgIdentity;
              this.regeisterInfo.regAddrType = this.ruleForm.regAddrType;
              this.regeisterInfo.companyId = this.ruleForm.selectCompanyId;
              if (this.ruleForm.regAddrType == '1') {
                this.regeisterInfo.licenceCode = this.ruleForm.licenceCode;
              }
              this.setToken("regeisterInfo", this.getAesString(JSON.stringify(this.regeisterInfo), this.KP.key, this.KP.iv));
              this.$router.push({path: '/registerBusinessInfo', query: {registeInviteCode: this.registeInviteCode}})
            }
          }).catch((err) => {
            console.log(err)
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
      // }

    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    goToHref(val) {
      this.$router.push({
        path: val,
        query: {
          companyName: this.ruleForm.companyName,
          orgIdentity: this.ruleForm.orgIdentity,
          regAddrType: this.ruleForm.regAddrType,
          companyId: this.selectCompanyId
        }
      })
    },
    loadCompanys(companyName) {
      this.selectCompanyName = '';
      this.searchVagueCompany = this.ruleForm.companyName;
      this.$axios.post('/onelink.mdata.main.api/credit/creditFuzzyQuery', {
        companyName: this.searchVagueCompany,
        pageNo: 1,
        pageSize: 10
      }).then((res) => {
        if (res.data.length > 0) {
          this.companyListShow = true;
        } else {
          this.$alert('<i class="el-icon-error" style="font-size: 32px;color: #F56C6C;position: absolute"></i><p style="padding-left: 48px">抱歉，没有找到相关结果！您可以:</p><p style="padding-left: 48px">1.输入准确的关键词，重新搜索</p><p style="padding-left: 48px">2.如果是非工商注册企业，请选择【境外及特殊企业】</p><p style="padding-left: 48px">3.点击屏幕右侧"咨询客服"与我们在线沟通。</p>', '', {
            dangerouslyUseHTMLString: true
          });
        }
        this.data = res.data;
        this.companyData = [];
//          if(this.data.length == 0){
//            this.$message({
//              dangerouslyUseHTMLString: true,
//              message: '<strong style="color:gray;font-size:8px">征信系统无法查询到您输入的企业信息<br/>请检查企业名称是否输入有误。<br/><p></p><br/>如有疑问请联系客服：0516-87796393</strong>',
//              type: 'success'
//            });
//            return false;
//          }
        this.companyData = this.data;
        this.ruleForm.companyName = this.searchVagueCompany;
      }).catch((err) => {
        console.log(err)
      })

    },
    selectCompany(companyId) {
      this.isSpeciaCo = false;
      this.selectCompanyId = companyId.split(",")[0];
      this.companySearch = this.selectCompanyName;
      this.selectCompanyName = companyId;
      this.ruleForm.companyName = companyId;
      this.$axios.post('/onelink.mdata.main.api/credit/creditAccurateQuery', {
        companyName: this.ruleForm.companyName,
        pageNo: 1,
        pageSize: 10
      }).then((res) => {
        this.data = res.data;
        if (this.data.length == 0) {
          this.$message({
            dangerouslyUseHTMLString: true,
            message: '<strong style="color:gray;font-size:8px">抱歉没有收到相关结果！你可以：<br/>1.输入准确的关键字，重新搜索<br/>2.点击屏幕右侧"咨询客服"与我们在线沟通。</strong>',
            type: 'error'
          });
          this.companyListShow = false;
          return false;
        }
        this.companyListShow = false;
        this.findCreditFlag = true;
        if (this.data.length > 0) {
          let currentCompanytInfo = this.data[0];
          if (currentCompanytInfo.creditNo == '' || currentCompanytInfo.creditNo == '-') {
            this.currentLienceCode = currentCompanytInfo.regNo;
          } else {
            this.currentLienceCode = currentCompanytInfo.creditNo;
          }
          // 通过三证判断是否是境外或特殊企业
          if (currentCompanytInfo.creditNo || currentCompanytInfo.creditNo.orgNo) {
            this.isSpeciaCo = false;
          } else {
            this.isSpeciaCo = true;
          }
        }
      }).catch((err) => {
        console.log(err)
      })


    },
    operateUser(flag) {
      this.userAgreementVisible = false;
      this.userChecked = flag;
      if (this.userChecked == true && this.privacyChecked == true) {
        this.disabledFlag = false;
      } else {
        this.disabledFlag = false;
      }
    },
    operatePrivacy(flag) {
      this.privacyPolicyVisible = false;
      this.privacyChecked = flag;
      if (this.userChecked == true && this.privacyChecked == true) {
        this.disabledFlag = false;
      } else {
        this.disabledFlag = false;
      }
    }


  }
}
</script>



// WEBPACK FOOTER //
// src/pages/register/index.vue